<template>
  <b-container
    fluid
    class="test-what text-color-light bg-color-dark pl-lg-5 pr-lg-5 pb-5"
  >
    <b-row>
      <b-col xl="1"></b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-row class="testimonials">
              <b-col xl="12">
                <h1 class="mb-4 pb-5 mt-3 text-color-light pt-5 big-headline">
                  Speakers
                </h1>
              </b-col>
            </b-row>
            <!-- ROW 1  -->
            <b-row>
              <b-col
                v-for="speaker in speakers.slice(0, 2)"
                md="3"
                cols="6"
                :key="speaker._id"
                class="speaker-card text-center mb-4"
                @click="setSpeaker(speaker, 1)"
              >
                <WorkshopSpeaker :speaker="speaker" :activeSpeaker="speakerId">
                </WorkshopSpeaker>
              </b-col>

              <WorkshopSpeakerExtended
                v-if="speaker._id == speakerId && row == 1"
                class="d-block d-sm-none"
                id="mobile-speaker"
                :speaker="speaker"
              >
              </WorkshopSpeakerExtended>
              <!-- ROW 2 -->
              <b-col
                v-for="speaker in speakers.slice(2, 4)"
                md="3"
                cols="6"
                :key="speaker._id"
                class="speaker-card text-center mb-4"
                @click="setSpeaker(speaker, 2)"
              >
                <WorkshopSpeaker :speaker="speaker" :activeSpeaker="speakerId">
                </WorkshopSpeaker>
              </b-col>

              <WorkshopSpeakerExtended
                v-if="speaker._id == speakerId && row == 2"
                class="d-block d-md-none"
                :speaker="speaker"
              >
              </WorkshopSpeakerExtended>
            </b-row>

            <!-- CENTER, only on big scrrens.  -->
            <div
              v-if="speaker"
              class="d-none d-md-flex justify-content-center mb-5"
            >
              <WorkshopSpeakerExtended :speaker="speaker">
              </WorkshopSpeakerExtended>
            </div>

            <b-row>
              <!-- ROW 3   -->
              <b-col
                v-for="speaker in speakers.slice(4, 6)"
                md="4"
                cols="6"
                :key="speaker._id"
                class="speaker-card text-center mb-4"
                @click="setSpeaker(speaker, 3)"
              >
                <WorkshopSpeaker
                  :speaker="speaker"
                  :activeSpeaker="speakerId"
                  :row2="true"
                >
                </WorkshopSpeaker>
              </b-col>

              <WorkshopSpeakerExtended
                v-if="speaker._id == speakerId && row == 3"
                class="d-block d-md-none"
                :speaker="speaker"
              >
              </WorkshopSpeakerExtended>
              <!-- ROW 4 -->
              <b-col
                v-for="speaker in speakers.slice(6, 7)"
                md="4"
                cols="6"
                :key="speaker._id"
                class="speaker-card text-center mb-4 position-relative"
                @click="setSpeaker(speaker, 4)"
              >
                <WorkshopSpeaker
                  :speaker="speaker"
                  :activeSpeaker="speakerId"
                  :row2="true"
                >
                </WorkshopSpeaker>
              </b-col>

              <WorkshopSpeakerExtended
                v-if="speaker._id == speakerId && row == 4"
                class="d-block d-md-none"
                :speaker="speaker"
              >
              </WorkshopSpeakerExtended>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col xl="1"></b-col>
    </b-row>
  </b-container>
</template>


<script>
import WorkshopSpeakerExtended from "./WorkshopSpeakerExtended.vue";
import WorkshopSpeaker from "./WorkshopSpeaker.vue";
export default {
  components: {
    WorkshopSpeakerExtended,
    WorkshopSpeaker,
  },
  data() {
    return {
      row: 0,
      speaker: false,
      speakerId: "",
      speakers: [
        {
          _id: "00",
          speakerFirstName: "Dennis",
          speakerLastName: "van der Stelt",
          workshopName: "Event Driven Microservices in Vertical Slices",
          speakerImageURL:
            "https://res.cloudinary.com/oredev/image/upload/v1686905035/2023_web/workshops/Dennisbw_1.png",
          date: "Tuesday, Nov 7th at 9am (90m)",
          info: [
            "You will learn how to keep microservices autonomous.",
            "You'll learn how to apply the 4+1 architectural view model to improve your architecture.",
            "You’ll better understand DDD concepts such as bounded contexts and data ownership.",
            "When back at the office, you'll find more ways to use the learned techniques to improve other parts of your system.",
            "The speaker has a GitHub repository with a solution that instantly runs in Visual Studio or Jetbrains Rider.",
          ],
        },
        {
          _id: "01",
          speakerFirstName: "Olle",
          speakerLastName: "E Johansson",
          workshopName:
            "First steps towards securing your software supply chain in the lights of the CRA",
          speakerImageURL:
            "https://res.cloudinary.com/oredev/image/upload/v1686905035/2023_web/workshops/Ollebw_1.png",
          date: "Tuesday, Nov 7th at 10.45am (90m)",
          info: [
            "What is a Software Bill of Materials (SBOM) and why you need it?",
            "Vulnerability disclosure - how to interact with your users and others.",
            "Vulnerability management - how to manage your dependencies?",
            "Software Supply Chain Security - how you manage build, test, release in a verifiable way.",
          ],
        },
        {
          _id: "02",
          speakerFirstName: "Anton",
          speakerLastName: "Kulaga",
          workshopName: "Hack Your Own Genome",
          speakerImageURL:
            "https://res.cloudinary.com/oredev/image/upload/v1686905035/2023_web/workshops/Antonbw_1.png",
          date: "Tuesday, Nov 7th at 1pm (90m)",
          info: [
            "How and where can I sequence your genome?",
            "How do health and longevity are connected with genetics? Which longevity genes do I have?",
            "How can I analyze my or somebodies genome with open-source tools and libraries?",
            "When I see an exciting gene or gene variant, how can I check it in my genome and interpret my genotype?",
            "Most of the traits are polygenic. How can I evaluate my polygenic risk scores",
            "Which types of genomic apps exist?",
            "The workshop will heavily utilize http://dna-seq.github.io/ open-source tools and apps that we develop.",
          ],
        },
        {
          _id: "03",
          speakerFirstName: "Emily",
          speakerLastName: "Bache",
          workshopName:
            "Introduction to Approval Testing: Get Your Legacy Code Under Control",
          speakerImageURL:
            "https://res.cloudinary.com/oredev/image/upload/v1686905035/2023_web/workshops/Emilybw_1.png",
          date: "Tuesday, Nov 7th at 1pm (90m)",
          info: [
            "Approval testing is a technique particularly suitable for legacy code.",
            "Approval testing easily goes wrong without good tools and appropriate test design.",
            "You exchange the complexity of designing Assertions for the complexity of designing a Printer.",
            "There are lots of approval testing tools to choose from.",
          ],
        },
        {
          _id: "04",
          speakerFirstName: "Rami",
          speakerLastName: "Krispin",
          workshopName: "Forecasting With Linear Regression",
          speakerImageURL:
            "https://res.cloudinary.com/oredev/image/upload/v1686905035/2023_web/workshops/Ramibw_1.png",
          date: "Tuesday, Nov 7th at 2.45pm (90m)",
          numeralList: true,
          info: [
            "Understanding the foundation of forecasting with regression methods",
            "Model different scenarios with features engineering",
            "When to use it (and when not)",
          ],
        },
        {
          _id: "05",
          speakerFirstName: "Tariq",
          speakerLastName: "King",
          workshopName: "Breaking Into AI and Machine Learning",
          speakerImageURL:
            "https://res.cloudinary.com/oredev/image/upload/v1686905035/2023_web/workshops/Tariqbw_1.png",
          date: "Friday, Nov 10th at 1.30pm (90m)",
          info: [
            "You'll learn the foundations of AI and machine learning",
            "You'll learn to apply a systematic process to machine learning with supporting tools.",
            "You'll get practice working on a small machine learning project end-to-end.",
            "You'll learn how to validate and evaluate ML learning models.",
          ],
        },
        {
          _id: "06",
          speakerFirstName: "Krzysztof",
          speakerLastName: "Slowinski",
          workshopName:
            "Engineering Scalable IaC Solutions to Overcome Cloud Limits",
          speakerImageURL:
            "https://res.cloudinary.com/oredev/image/upload/v1686905035/2023_web/workshops/Krzysztofbw_1.png",
          date: "Friday, Nov 10th at 3.15pm (90m)",
          numeralList: true,
          info: [
            "Discover a few important limits that come with building complex cloud architectures using Infrastructure as Code (IaC).",
            "Implement various patterns and effective solutions.",
            "Gain a practical insight into the trade-offs that cloud engineers have to face when working on larger projects.",
          ],
        },
      ],
    };
  },
  methods: {
    setSpeaker(speaker, row) {
      if (speaker._id === this.speakerId) {
        this.speaker = false;
        this.speakerId = "";
        this.row = 0;
        return;
      }
      this.row = row;
      this.speakerId = speaker._id;
      this.speaker = speaker;
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../styles/variables.scss";
</style>



// WEBPACK FOOTER //
// src/components/WorkshopSpeakers.vue